import { AloUser,getDefaultAloUser, cleanAloUser } from '@/models/alo/AloUser'
import { AloBase, getDefaultAloBase } from '@/models/alo/AloBase'

export interface AloPersonne extends AloBase {    
    
    ensId: number
    prsNom: string
    prsPrenom: string
    prsEmail: string
    prsTel: string
    prsNote: string
    usr: AloUser
}

export const getDefaultAloPersonne = ():AloPersonne => {
    return {   
        ...getDefaultAloBase(),
        ensId:0,
        prsNom:"",
        prsPrenom:"",
        prsEmail:"",
        prsTel:"",
        prsNote:"",
        usr:getDefaultAloUser()
    } 
}

export const cleanAloPersonne = (personne:AloPersonne) => {
    if(!personne) return    
    if(!personne.id) delete personne.id
    if(!personne.ensId) delete personne.ensId
    cleanAloUser(personne.usr)
}

